import { topLines } from "@/mocks/portal";

export default function TopLines() {
  return (
    <section id="hot" className="mx-auto max-w-[1200px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-1">
        <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
          <i className="ri-fire-line text-sm" aria-hidden="true" />
          Trending
        </span>
        <h2 className="text-lg font-bold text-foreground-950 md:text-2xl">此刻被反复对比的线路</h2>
        <p className="text-xs text-foreground-500 md:text-sm">
          热度基于近 24h 被查看/测速的次数，右侧可用性为编辑口径参考，帮你判断“哪个好用”的大方向。
        </p>
      </div>

      <div className="mt-6 flex flex-col gap-3">
        {topLines.map((row) => (
          <a
            key={row.rank}
            href="#compare"
            className="group grid grid-cols-[auto_1fr_auto] items-center gap-3 rounded-xl border border-background-200 bg-background-100 px-4 py-3 transition-colors hover:border-primary-300 hover:bg-primary-50 md:grid-cols-[auto_1.4fr_1fr_auto] md:gap-5 md:px-5 md:py-4"
          >
            <span
              className={`font-num grid h-9 w-9 place-items-center rounded-lg text-lg font-bold ${
                row.rank === 1 ? "bg-accent-500 text-background-50" : row.rank === 2 ? "bg-accent-100 text-accent-700" : "bg-background-200 text-foreground-600"
              }`}
            >
              {String(row.rank).padStart(2, "0")}
            </span>

            <div className="flex min-w-0 items-center gap-3">
              <div className="min-w-0">
                <p className="flex flex-wrap items-center gap-2 text-sm font-bold text-foreground-950 md:text-[15px]">
                  {row.name}
                  {row.best && (
                    <span className="whitespace-nowrap rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-semibold text-background-50">
                      今日易用
                    </span>
                  )}
                  <span className="whitespace-nowrap rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-semibold text-primary-700">
                    {row.tag}
                  </span>
                </p>
                <p className="mt-1 hidden text-[12px] text-foreground-500 sm:block">可用性 {row.up} · 综合参考分 4.x</p>
              </div>
            </div>

            <div className="hidden justify-end gap-6 md:flex">
              <div className="text-right">
                <p className="text-[11px] text-foreground-500">近24h热度</p>
                <p className="font-num text-sm font-bold text-foreground-950">{row.heat}</p>
              </div>
              <div className="text-right">
                <p className="text-[11px] text-foreground-500">可用性</p>
                <p className="font-num text-sm font-bold text-primary-600">{row.up}</p>
              </div>
            </div>

            <span className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-500">
              <span className="font-num inline-flex items-center gap-0.5 rounded-full bg-background-200 px-2 py-1 text-accent-600">
                {row.move === "→" ? <i className="ri-arrow-right-line text-[12px]" aria-hidden="true" /> : <i className="ri-arrow-up-line text-[12px]" aria-hidden="true" />}
                {row.move}
              </span>
              <i className="ri-arrow-right-line text-base text-primary-400 transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </span>
          </a>
        ))}
      </div>

      <p className="mt-3 text-center text-[11px] text-foreground-400">热榜仅为浏览参考，不代表任何服务方立场。</p>
    </section>
  );
}